<template>
  <v-dialog max-width="85%" v-model="model" persistent>
    <v-card v-if="loading">
      <v-card-title>
        Requisitos del Puesto - {{ puesto?.nombre || '—' }}
      </v-card-title>

      <v-card-text class="text-center py-8">
        <v-progress-circular
          indeterminate
          size="32"
          width="3"
          class="mb-3"
        ></v-progress-circular>
        <div class="text-subtitle-2">
          Cargando Requisitos del Puesto ...
        </div>
      </v-card-text>
    </v-card>

    <v-card v-else>
      <v-card-title class="justify-space-between">
        <div>
          Requisitos del Puesto - {{ puesto?.nombre || '—' }}
        </div>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers_requisitos"
          :items="requisitosEdit"
          item-key="id_puesto_expediente_requisito"
          dense
          :items-per-page="-1"
          hide-default-footer
          :loading="loadingRequisitos"
        >
          <template v-slot:body>
            <draggable
              v-model="requisitosEdit"
              handle=".drag-handle"
              tag="tbody"
              @end="on_drag_end_requisitos"
            >
              <tr v-for="(item, idx) in requisitosEdit" :key="`row-${idx}`">
                <!-- Orden / Drag handle -->
                <td class="text-center" style="width:50px;">
                  <v-icon small class="drag-handle" style="cursor:grab;">mdi-drag</v-icon>
                </td>

                <!-- Nombre -->
                <td>
                  <v-autocomplete
                    v-model="item.id_expediente_requisito"
                    :items="expedienteRequisitos"
                    item-text="nombre"
                    item-value="id_expediente_requisito"
                    dense
                    hide-details
                    outlined
                    class="py-2"
                  >
                  </v-autocomplete>
                </td>

                <!-- Tipo -->
                <td>{{ get_tipo_documento(item.id_expediente_requisito) }}</td>

                <!-- Requerido centrado -->
                <td class="text-center">
                  <div class="d-flex justify-center">
                    <v-checkbox
                      v-model="item.requerido"
                      hide-details
                      dense
                      class="ma-0 pa-0"
                    />
                  </div>
                </td>

                <!-- Nota -->
                <td>
                  {{get_nota(item.id_expediente_requisito)}}
                </td>

                <td>
                  <v-btn icon small @click="removeRequisito(idx)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </draggable>
          </template>
        </v-data-table>
        <br>
        <v-btn color="primary" small outlined @click="addRequisito">
          <v-icon left small >mdi-plus</v-icon>Agregar requisito
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="green" text @click="close">Cerrar</v-btn>
        <v-btn color="red" text :loading="loadingSave" @click="save">Guardar cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios"

export default {
  name: "PuestoRequisitosDialog",
  components: { draggable },
  props: {
    value: { type: Boolean, default: false }, // v-model
    puesto: { type: Object, default: () => null },
    loading: { type: Boolean, default: false }, // opcional si quieres mostrar loading externo
  },
  data: () => ({
    requisitosEdit: [],
    headers_requisitos: [
      { text: "Orden", value: "orden", align: "center", width: "6%" },
      { text: "Nombre", value: "nombre", align: "start", width: "40%" },
      { text: "Tipo", value: "tipo_documento", align: "start", width: "10%" },
      { text: "Requerido", value: "requerido", align: "center", width: "8%" },
      { text: "Nota", value: "nota", align: "start", width: "28%" },
      { text: "", value: "actions", align: "center", width: "8%" },
    ],
    loadingRequisitos: false,
    expedienteRequisitos: [],
    loadingSave: false,
  }),
  computed: {
    model: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    }
  },
  watch: {
    puesto: {
      immediate: true,
      handler(val) {
        const src = Array.isArray(val?.expediente_requisitos) ? val.expediente_requisitos : [];
        const cloned = JSON.parse(JSON.stringify(src))
          .map((r, i) => ({
            ...r,
            posicion: Number.isInteger(+r.posicion) ? +r.posicion : (i + 1),
          }))
          .sort((a, b) => a.posicion - b.posicion);

        this.requisitosEdit = cloned;
      }
    },
    value(v) {
      // Al abrir, re-normaliza por si hubo cambios en el padre
      if (v && this.puesto) {
        const src = Array.isArray(this.puesto.expediente_requisitos) ? this.puesto.expediente_requisitos : [];
        const cloned = JSON.parse(JSON.stringify(src))
          .map((r, i) => ({
            ...r,
            posicion: Number.isInteger(+r.posicion) ? +r.posicion : (i + 1),
          }))
          .sort((a, b) => a.posicion - b.posicion);

        this.requisitosEdit = cloned;
      }
    }
  },
  mounted(){
    this.getExpedienteRequisitos();
  },
  methods: {
    getExpedienteRequisitos() {
      this.loadingRequisitos = true;
      axios
        .get('/RecursosHumanos/ListarExpedienteRequisitos')
        .then(response => {
          this.expedienteRequisitos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRequisitos = false;
        });
    },
    addRequisito() {
      this.requisitosEdit.push({
        id_expediente_requisito: null,
        posicion: null,
        requerido: false,
      });
    },
    removeRequisito(i) {
      this.requisitosEdit.splice(i, 1);
    },
    on_drag_end_requisitos() {
      this.requisitosEdit = this.requisitosEdit.map((r, i) => ({ ...r, posicion: i + 1 }));
    },
    get_tipo_documento(id_expediente_requisito) {
      let expReq = this.expedienteRequisitos.find(x => x.id_expediente_requisito == id_expediente_requisito);

      if(!expReq) return '';
      
      switch (expReq.tipo_documento) {
        case 1: return 'Archivo';
        case 2: return 'Texto Libre';
        case 3: return 'Número de Teléfono';
        case 4: return 'Correo Electrónico';
        default: return '';
      }
    },
    get_nota(id_expediente_requisito) {
      let expReq = this.expedienteRequisitos.find(x => x.id_expediente_requisito == id_expediente_requisito);
      if(!expReq) return '';
      return expReq.nota;
    },
    close() {
      this.$emit("input", false);
      this.$emit("close", null);
    },
    save() {
      const reqs = this.requisitosEdit.map((r, i) => ({ ...r, posicion: i + 1 }));

      this.loadingSave = true;

      axios
      .post(`/RecursosHumanos/GuardarPuestoRequisitos/${this.puesto.id_puesto}`, reqs)
        .then(() => {
          this.close();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
  }
};
</script>

<style scoped>
.drag-handle { padding: 4px; }
</style>
